// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "recommendations-" + chunkId + ".js?v=" + {"node_modules_nextcloud_vue_dist_Components_NcColorPicker_mjs":"1a8ba9235454936c9ddf","node_modules_nextcloud_vue_dist_Components_NcSelect_mjs":"f0c7a597a98c697066bc","vendors-node_modules_rehype-highlight_index_js":"278c24bab53a2c9e34f6"}[chunkId] + "";
};